import { Controller } from "stimulus"

const TOAST_HOST_ID = "next-steps-toasts"

export default class extends Controller {
  connect() {
    this.initTooltips(this.element)
  }

  disconnect() {
    this.disposeTooltips(this.element)
    this.unlock()
  }

  lock() {
    this.submitButtons.forEach((button) => {
      button.disabled = true
    })
  }

  unlock() {
    this.submitButtons.forEach((button) => {
      button.disabled = false
    })
  }

  get submitButtons() {
    return [this.element, document.getElementById(TOAST_HOST_ID)]
      .filter(Boolean)
      .flatMap((scope) => Array.from(scope.querySelectorAll('button[type="submit"]')))
  }

  initTooltips(scope) {
    if (window.$) window.$('[data-toggle="tooltip"]', scope).tooltip({ html: true })
  }

  // Guard on an existing instance — Bootstrap 4 throws on "dispose" when none was
  // initialized.
  disposeTooltips(scope) {
    if (!window.$) return
    window.$('[data-toggle="tooltip"]', scope).each(function () {
      const $el = window.$(this)
      if ($el.data("bs.tooltip")) $el.tooltip("dispose")
    })
  }
}
